import { useQuery } from 'react-query';

import APIs from '../api';
import { setAssetsList } from '../reducer/assetSlice';
import { useAppDispatch, useAppSelector } from '../reducer/hooks';
import { selectMerchantList, setMerchantList } from '../reducer/merchantListSlice';

interface IProps {
  shouldFetch?: boolean;
}

const useMerchantList = (props: IProps = {}) => {
  const { shouldFetch } = props;

  const dispatch = useAppDispatch();
  const { list: merchantList } = useAppSelector(selectMerchantList);

  const handleQuery = async () => {
    const res = await APIs.Query.getMerchantListQuery();
    return res;
  };

  useQuery(['merchantList'], handleQuery, {
    onSuccess: (data) => {
      dispatch(setMerchantList(data));
    },
    enabled: shouldFetch,
  });

  const getMerchantInfo = (merchantId: string | number) => {
    return merchantList.find((merchant) => Number(merchant.merchantId) === Number(merchantId));
  };

  return {
    merchantList,
    getMerchantInfo,
  };
};

export default useMerchantList;
